import { useTheme, type ThemePreference } from '../../theme/theme-provider';

/**
 * Three-way theme picker — Light / Dark / System. Lives inside the profile
 * dropdown but exported as a standalone component so settings pages can
 * reuse it later.
 */

const OPTIONS: Array<{ value: ThemePreference; label: string; icon: string }> = [
  { value: 'light', label: 'Světlý', icon: '☀' },
  { value: 'dark', label: 'Tmavý', icon: '☾' },
  { value: 'system', label: 'Systém', icon: '⌬' },
];

export function ThemeToggle() {
  const { preference, setPreference } = useTheme();

  return (
    <div
      role="radiogroup"
      aria-label="Barevný motiv"
      className="inline-flex rounded-md border border-surface-border bg-surface-muted p-0.5"
    >
      {OPTIONS.map((option) => {
        const selected = option.value === preference;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => setPreference(option.value)}
            className={
              selected
                ? 'flex items-center gap-1 rounded px-2 py-1 text-xs font-medium bg-surface text-slate-900 shadow-sm dark:text-slate-50'
                : 'flex items-center gap-1 rounded px-2 py-1 text-xs text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'
            }
          >
            <span aria-hidden="true">{option.icon}</span>
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
